export interface NavGroup {
  title: string
  links: string[]
}

export interface NavMenu {
  label: string
  groups: NavGroup[]
}

/**
 * Les trois menus réels de beaconsfield.ca, avec leurs sections et leurs entrées.
 * Relevés sur le site, pas inventés — d'où des listes longues et inégales.
 */
export const navItems: NavMenu[] = [
  {
    label: 'Ma ville',
    groups: [
      {
        title: 'Vivre à Beaconsfield',
        links: [
          'Actualités',
          'Carte interactive',
          'Commémoration',
          'Contexte et histoire',
          'Être un bon voisin',
          'Événements à venir',
          'Inscriptions en ligne',
          'Magazine CONTACT et Info-flash',
          'Nous joindre',
          'Nouveaux résidents',
          'Portail citoyen',
          'Recherche par adresse',
          'Sondages et études',
        ],
      },
      {
        title: 'Administration et finances',
        links: [
          'Accès aux documents',
          'Agglomération et CMM',
          'Appel d’offres et contrats',
          'Assermentation',
          'Avis publics',
          'Budget et rapport financier',
          'Emplois',
          'Faire une réclamation',
          'Règlements municipaux',
          'Taxes et rôle d’évaluation',
        ],
      },
      {
        title: 'Votre conseil',
        links: [
          'Conseil municipal',
          'Comités',
          'Districts électoraux',
          'Élections municipales',
          'Séances du conseil et procès-verbaux',
        ],
      },
    ],
  },
  {
    label: 'Services',
    groups: [
      {
        title: 'Services aux citoyens',
        links: [
          'Animaux',
          'Carte interactive',
          'Connectons Beaconsfield',
          'Demande de permis et certificats',
          'Déneigement',
          'Gestion des matières résiduelles',
          'Inscription en ligne',
          'Portail citoyen',
          'Registre des personnes vulnérables',
          'Réservation de salles et d’installations',
          'Sécurité publique',
          'Services aux aînés',
          'Services en ligne',
          'Subventions et aides financières',
        ],
      },
      {
        title: 'Environnement et travaux publics',
        links: [
          'Agir pour le climat à Beaconsfield',
          'Arbres et végétaux',
          'Déneigement',
          'Devenir plus résilient',
          'Eau',
          'Gestion des matières résiduelles',
          'Parcs et espaces verts',
          'Remplacement des compteurs d’eau',
          'Travaux publics',
        ],
      },
      {
        title: 'Urbanisme et permis',
        links: [
          'Documentation',
          'PPCMOI',
          'Permis et certificats',
          'Refonte du plan et des règlements',
          'Réglementation d’urbanisme',
          'Sécurité des piscines résidentielles',
          'Trouvez votre zonage',
        ],
      },
    ],
  },
  {
    label: 'Culture et loisirs',
    groups: [
      {
        title: 'Loisirs et vie communautaire',
        links: [
          'Associations reconnues',
          'Bourses et subventions',
          'Camps d’été',
          'Demande de remboursement ou de transfert',
          'Événements spéciaux',
          'Fête de quartier',
          'Horaire des activités libres',
          'Inscription aux activités',
          'Plan d’accessibilité universelle',
          'Programmation des loisirs',
          'Services aux aînés',
        ],
      },
      {
        title: 'Installations et parcs',
        links: [
          'Accès à l’eau',
          'Carte interactive des parcs',
          'Centre récréatif',
          'Parcs et terrains de jeux',
          'Patinoires extérieures et ski de fond',
          'Piscines communautaires',
          'Réservation de salles et d’installations',
        ],
      },
      {
        title: 'Bibliothèque et culture',
        links: [
          'Bibliothèque',
          'Centre culturel',
          'Événements spéciaux',
          'Expositions',
          'Services et associations',
        ],
      },
    ],
  },
]
